import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "terms-container" };
const _hoisted_2 = ["src"];
import { ref, onMounted, onBeforeUnmount } from 'vue';
import DrawerPanel from './DrawerPanel.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'QuizDrawerTermsPanel',
    props: {
        termsUrl: { default: 'https://s3.eu-west-2.amazonaws.com/content.sysodev.link/5713bc01-QuizTerms.pdf#view=FitH' }
    },
    setup(__props, { expose: __expose }) {
        const termsdrawer = ref(null);
        const wasHidden = ref(false);
        function openDrawer() {
            termsdrawer.value?.openDrawer();
            wasHidden.value = false;
        }
        function closeDrawer() {
            termsdrawer.value?.closeDrawer();
        }
        function handleVisibilityChange() {
            if (document.hidden) {
                wasHidden.value = true;
            }
            else if (wasHidden.value) {
                wasHidden.value = false;
                closeDrawer();
            }
        }
        onMounted(() => {
            document.addEventListener('visibilitychange', handleVisibilityChange);
        });
        onBeforeUnmount(() => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        });
        __expose({ openDrawer, closeDrawer });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(DrawerPanel, {
                ref_key: "termsdrawer",
                ref: termsdrawer,
                title: "Terms & Conditions",
                bottom: "-32px",
                openHeight: "95%",
                closedHeight: "0px",
                startOpened: false,
                back: true,
                close: true,
                divider: true,
                backgroundColor: "#FFFFFF",
                openBackgroundColor: "#FFFFFF",
                onGoBack: closeDrawer
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("iframe", {
                            src: _ctx.termsUrl,
                            class: "terms-iframe",
                            frameborder: "0"
                        }, null, 8, _hoisted_2)
                    ])
                ]),
                _: 1
            }, 512));
        };
    }
});
